import {
  SET_WORK_CALENDAR_DATA,
  CLEAR_WORK_CALENDAR_DATA,
  SET_WORK_CALENDAR_LOADING,
  SET_SELECTED_DISPLAY_METRIC,
} from "../actions/work-calendar-action";
import { METRIC } from "src/components/MultiDateTimeCalendar/calendarUtils";

const initialState = {
  workCalendarData: null,
  isLoading: false,
  selectedDisplayMetric: {
    text: "Total Hours",
    value: METRIC.HOURS,
    key: "hours",
  },
};

const workCalendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WORK_CALENDAR_DATA:
      return {
        ...state,
        workCalendarData: action.payload,
      };
    case CLEAR_WORK_CALENDAR_DATA:
      return {
        ...state,
        workCalendarData: null,
      };
    case SET_WORK_CALENDAR_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_SELECTED_DISPLAY_METRIC:
      return {
        ...state,
        selectedDisplayMetric: action.payload,
      };
    default:
      return state;
  }
};

export default workCalendarReducer;
